import Immutable from 'immutable'

import { getDataByForeignId } from '../../services/immutableUtils'
import { formatOneDate } from '../../services/utils'

const today = formatOneDate(new Date())

export const getModulationPeriodForLocation = (state, locationId) => {
  if (!locationId) {
    return undefined
  }

  const modulationPeriods = getDataByForeignId(
    state,
    'modulationPeriods',
    'location_id',
    locationId
  )

  return modulationPeriods
}

export const getCurrentModulationPeriodForLocation = (state, locationId) => {
  const modulationPeriods =
    getModulationPeriodForLocation(state, locationId) || Immutable.Map()

  if (modulationPeriods.size === 0) {
    return undefined
  }

  return modulationPeriods.find(
    ({ start_date: startDate, end_date: endDate }) =>
      startDate <= today && endDate >= today
  )
}

export const getModulationPeriodById = (state, modulationPeriodId) => {
  if (!modulationPeriodId) {
    return undefined
  }

  return state.modulationPeriods.getIn(['data', Number(modulationPeriodId)])
}

export const getModulationPeriodByLocationIdAndWeek = (
  state,
  locationId,
  week
) => {
  if (!locationId || !week) {
    return
  }

  const formatedWeek = formatOneDate(week)
  const modulationPeriods = getModulationPeriodForLocation(state, locationId)

  if (!modulationPeriods) {
    return
  }

  return modulationPeriods.find(
    ({ start_date: startDate, end_date: endDate }) =>
      startDate <= formatedWeek && endDate >= formatedWeek
  )
}

export const getModulationPeriodMeta = state =>
  state.modulationPeriods.get('meta')
